import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';
import { email } from 'Utils/validations';

const LoginFormSchema = Yup.object().shape(
  reverseShape({
    accountType: Yup.mixed().oneOf(['BUSINESS_ACCOUNT', 'INDIVIDUAL_ACCOUNT']),
    email: email.required(),
    password: Yup.string().required(),
  })
)

export default LoginFormSchema;
